import React from 'react';
import { Bell } from '@phosphor-icons/react';

const UpdatesPage = () => {
  return (
    <div className="min-h-screen bg-background p-6">
      <div className="max-w-4xl mx-auto">
        <div className="text-center py-20">
          <Bell size={64} className="mx-auto mb-4 text-gold" weight="light" />
          <h2 className="text-2xl font-heading font-medium text-text-primary mb-2">
            Regulatory Updates
          </h2>
          <p className="text-text-secondary">
            Stay tuned for real-time regulatory changes and updates
          </p>
        </div>
      </div>
    </div>
  );
};

export default UpdatesPage;
